import {useTranslation} from "react-i18next";
import styles from "./languageSwitcher.module.less";

const GlobeIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
)

export const LanguageSwitcher = () => {
    const { i18n } = useTranslation()
    const currentLang = i18n.language

    const handleLanguageChange = (lang: string) => {
        i18n.changeLanguage(lang)
    }

    return (
        <div className={styles.languageSwitcher}>
            <GlobeIcon />
            <button
                type="button"
                className={`${styles.langButton} ${currentLang === 'ja-JP' ? styles.langButtonActive : ''}`}
                onClick={() => handleLanguageChange('ja-JP')}
            >
                日本語
            </button>
            <span className={styles.langDivider}>|</span>
            <button
                type="button"
                className={`${styles.langButton} ${currentLang === 'en-US' ? styles.langButtonActive : ''}`}
                onClick={() => handleLanguageChange('en-US')}
            >
                English
            </button>
        </div>
    )
}